export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6921.b55e069a.jpg";